import { NgModule } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TestimonialsComponent } from '../../common/testimonials/testimonials.component';
import { OurSponsorsComponent } from '../../common/our-sponsors/our-sponsors.component';

@NgModule({
  declarations: [
    TestimonialsComponent,
    OurSponsorsComponent
  ],
  imports: [
    CarouselModule
  ],
  exports: [
    TestimonialsComponent,
    OurSponsorsComponent
  ]
})
export class SharedComponentsModule {}
